import React from "react";
import { TextField, SelectInput, AutocompleteInput } from "react-admin";
import { ReferenceEditableField } from "./EditableField";
const defaultSort = {
	field: "first_name",
	order: "ASC",
};

const optionText = (r) => (r ? `${r.first_name} ${r.last_name}` : null);

export const OSFCUserSelectField = ({ visibleSource, ...props }) => {
	return (
		<ReferenceEditableField
			reference="company-users"
			perPage={15}
			{...props}
			optimized={true}
			editField={<AutocompleteInput optionText={optionText} resettable emptyValue="" />}
			filter={{
				no_range: false,
				is_terminal: true,
				is_blocked: false,
				is_deleted: false,
				...props.filter,
			}}
			sort={defaultSort}
			format={(value) => (value === 0 ? "" : value)}
			parse={(value) => (value === "" ? 0 : value)}
		>
			<TextField source={visibleSource} />
		</ReferenceEditableField>
	);
};
